// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__QcSD9","links":"Navbar_links__nbeOo","mobile_btn":"Navbar_mobile_btn__7z3EE","active":"Navbar_active__uB-3p"};